<template>
  <div class="header login">
    <v-navigation-drawer
      v-model="drawer"
      app
      right
      width="70%"
      height="100vh"
      class="sidebar show-res"
      hide-overlay
    >
      <div
        @click="toggleSidebar()"
        class="drawer-hide ms-5"
        width="25"
        height="63"
        contain
        v-if="drawer"
      >
        <v-icon>mdi-close</v-icon>
      </div>
      <div class="sidebar__avatar-wrapper" dir="rtl">
        <v-row class="align-center justify-center">
          <v-col cols="5" class="d-flex align-center justify-center">
            <img :src="config.secondLogoAddress" width="80%" alt="logo of company" />
          </v-col>
          <v-col cols="7" class="d-flex align-center justify-start">
            <h1 class="text-p-dark">{{ config.title }}</h1>
          </v-col>
        </v-row>
      </div>

      <v-list  dir="rtl"
        class="sidebar-items"
        density="compact"
        nav
        v-for="mMenu in menus.filter((menus) => menus.name === 'Main')"
        :key="mMenu.id">
        <template   v-for="(item, index) in mMenu.children"
          >
          <v-list-item
            v-if="item.isActive"
            :key="index"
            :to="item.link"
            link
          >
            <v-list-item-content>
              <v-list-item-title
                class="d-flex align-center justify-space-between"
              >
                <v-icon class="me-2 icon-sidebar">mdi-circle</v-icon>
                <span
                  class="text-start text-p-dark p-fw-bold"
                  style="width: 283px"
                >
                {{ item.text }}
                </span>
                <div class="arrow-circle">
                  <v-icon class="p-fs-xl">mdi-chevron-left</v-icon>
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <!-- <v-row>
        <v-col cols="12" class="d-flex justify-center mt-2">
          <v-btn
            color="first"
            height="45px"
            width="90%"
            class="intro-btn p-fs-m radius-p-l text-p-white"
            small
            depressed
            @click="gotToLogin"
          >
            ورود/ ثبت نام
          </v-btn>
        </v-col>
      </v-row> -->
      <v-divider
        class="mt-10"
        style="border-color: #f76465; opacity: 0.2"
      ></v-divider>
      <v-row dir="rtl" class="mt-5" v-if="config.address">
        <v-col cols="12" class="d-flex align-center">
          <v-icon class="me-1">mdi-map-marker-outline</v-icon>
          <h5 class="text-p-muted mt-2">
            {{ config.address }}
          </h5>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex align-center pt-0" v-if="config.tel">
          <v-icon class="me-1">mdi-phone-outline</v-icon>
          <h4 class="text-p-muted mt-2">{{ config.tel }}</h4>
        </v-col>
        <v-col cols="12" class="d-flex align-center pt-0" v-if="config.email">
          <v-icon class="me-1">mdi-email-outline</v-icon>
          <h4 class="text-p-muted mt-2">{{ config.email }}</h4>
          <h3></h3>
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12" class="d-flex justify-center share-icon">
          <a
            v-for="item in socials.filter(
              (z) => z.isActive && z.link.length > 1
            )"
            :key="item.id"
            class="pa-1 rounded-circle ml-1 icon-btn"
            :href="item.link"
          >
            <v-img :src="item.iconAddress" contain alt="icon of social network" />
          </a>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <!-- Desktop Menu -->
    <!-- <div class="header__top hide-res">
      <v-container>
        <v-row>
          <v-col cols="5" md="3" sm="2" class="pt-5 ps-10 d-flex">
            <a
              v-for="item in socials.filter(
                (z) => z.isActive && z.link.length > 1
              )"
              :key="item.id"
              class="pa-1 rounded-circle ml-1 icon-btn"
              :href="item.link"
            >
              <v-img :src="item.iconAddress" contain alt="icon of social network" />
            </a>
          </v-col>
          <v-col cols="7" md="9" sm="10" class="d-flex pt-2">
            <v-row>
              <v-col cols="4" class="d-flex align-center email-text-login"  v-if="config.email">
                <v-icon class="me-2 text-p-first">mdi-email</v-icon>
                <h4 class="p-fw-semibold">{{ config.email }}</h4>
              </v-col>
              <v-col cols="8" class="d-flex align-center"  v-if="config.address">
                <v-icon class="me-2 text-p-first">mdi-map-marker-radius</v-icon>
                <h5 class="p-fw-semibold address-text-login">
                  {{ config.address }}
                </h5>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <v-app-bar flat color="#1e2843" class="header__menu">
      <v-row class="align-center">
        <v-col cols="2" class="show-res text-center">
          <div @click="toggleSidebar()" elevation="0" fab v-if="!drawer">
            <i class="fas fa-bars p-fs-xxxl text-p-white"></i>
          </div>
        </v-col>
      </v-row>
      <div
        class="text-center text-p-white hide-res"
        v-for="topMenu in menus.filter((menus) => menus.name === 'Main')"
        :key="topMenu.id"
      >
        <div
          v-for="menu in topMenu.children.filter(
            (topMenu) => topMenu.children === null
          )"
          :key="menu.id"
        >
          <v-btn text v-if="menu.isActive" @click="routeLink(menu)">
            {{ menu.text }}
          </v-btn>
        </div>
      </div>
      <div class="menu-phone hide-res menu-phone-login" v-if="config.tel">
        <div class="circle-phone me-2">
          <v-icon class="text-p-first">mdi-phone</v-icon>
        </div>
        <h4 class="text-p-white p-fw-semibold">تلفن: {{ config.tel }}</h4>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheHeaderLofin",
  computed: {
    ...mapGetters({
      menus: "baseX/menus",
      config: "baseX/config",
      socials: "clientX/socials",
    }),
    routeName() {
      return this.$route.name;
    },
  },
  components: {},
  data() {
    return {
      alert,
      label,
      drawer: null,
    
    };
  },
  methods: {
    toggleSidebar() {
      this.drawer = !this.drawer;
    },
    logout() {
      this.$store.dispatch("panelX/logout");
    },
    setStaticLink(item) {
      if (item.startsWith("/", 0)) {
        return item;
      } else {
        return "/" + item;
      }
    },
    routeLink(menu) {
      if (menu.link.indexOf("https") === 0 || menu.link.indexOf("http") === 0) {
        window.open(menu.link, "_blank");
      } else {
        this.$router.push(this.setStaticLink(menu.link));
      }
    },
  },
  beforeCreate() {
    this.$store.dispatch("baseX/getMenus");
    this.$store.dispatch("baseX/getConfig");
    this.$store.dispatch("clientX/getSocials");
  },
};
</script>
